import React from 'react';
import CompareArrowsIcon from '@material-ui/icons/CompareArrows';
import PartialIcon from '../PartialIcon'
import './ShiftCard.scss';

export const EmployeeName = ({
    employeeName, employeeNumber
}) => (
    <div className="employee-name-wrapper">
        <span className="employee-name text-sm-semibold">{employeeName}</span>
        {!!employeeNumber && (<span className="employee-number text-sm-regular">{employeeNumber}</span>)}
    </div>
);

export const ShiftCard = ({
    employeeName,
    employeeNumber,
    employeeAvatar,
    shiftLabel,
    shiftDescription,
    shiftCardColorClass,
    hasTransfer,
    isPartial = false
}) => (
    <div className="shift-card-container">
        {!!employeeName && (
            <EmployeeName
                employeeName={employeeName}
                employeeNumber={employeeNumber}
            />
        )}
        <div className="shift-card-wrapper">
            <div className={`shift-card-left-border ${shiftCardColorClass}`} />
            <div className="shift-card">
                {!!employeeAvatar
                    && (
                        <div className="employee-avatar text-sm-semibold">{employeeAvatar}</div>
                    )
                }
                <div className="shift-card-info">
                    <div className="period-container">
                        <span className="text-sm-semibold">{shiftLabel}</span>
                        <div className="margin-right-auto" />
                        {!!hasTransfer && (
                            <div className="transfer-icon-wrapper"><CompareArrowsIcon /></div>
                        )}
                        {isPartial && (
                            <div className="partial-icon-wrapper"><PartialIcon /></div>
                        )}
                    </div>
                    <span className="text-xs-medium">{shiftDescription}</span>
                </div>
            </div>
        </div>
    </div>
);
